import { Env, ENVS, getEnv, getRegion } from '@adsk/acs-sc-web-platform-api';

import { Route } from './types';

export type EnvRemoteConfig = {
  remoteRoutes: Route[];
};

let envConfig: EnvRemoteConfig | undefined;

const configFactoryByEnvs: Record<
  Env,
  (params: { region: string }) => Promise<EnvRemoteConfig>
> = {
  [ENVS.QA]: () => {
    return import('./remote-routes/remote-routes.qa.us').then(
      ({ default: remoteRoutes }) => ({ remoteRoutes }),
    );
  },
  [ENVS.STAGING]: ({ region }: { region: string }) => {
    switch (region) {
      case 'APAC': {
        return import('./remote-routes/remote-routes.staging.apac').then(
          ({ default: remoteRoutes }) => ({ remoteRoutes }),
        );
      }
      case 'AUS': {
        return import('./remote-routes/remote-routes.staging.aus').then(
          ({ default: remoteRoutes }) => ({ remoteRoutes }),
        );
      }
      default: {
        return import('./remote-routes/remote-routes.staging.us').then(
          ({ default: remoteRoutes }) => ({ remoteRoutes }),
        );
      }
    }
  },
  [ENVS.PRODUCTION]: ({ region }: { region: string }) => {
    switch (region) {
      case 'EMEA': {
        return import('./remote-routes/remote-routes.production.emea').then(
          ({ default: remoteRoutes }) => ({ remoteRoutes }),
        );
      }
      case 'APAC': {
        return import('./remote-routes/remote-routes.production.apac').then(
          ({ default: remoteRoutes }) => ({ remoteRoutes }),
        );
      }
      case 'AUS': {
        return import('./remote-routes/remote-routes.production.aus').then(
          ({ default: remoteRoutes }) => ({ remoteRoutes }),
        );
      }
      default: {
        return import('./remote-routes/remote-routes.production.us').then(
          ({ default: remoteRoutes }) => ({ remoteRoutes }),
        );
      }
    }
  },
};

export const clearEnvConfig = () => {
  envConfig = undefined;
};

export const loadEnvConfig = async () => {
  const env = getEnv();
  const region = getRegion();

  const configFactory = configFactoryByEnvs[env];

  if (!configFactory) {
    throw Error(`Cannot find environment factory for 'env': "${env}"`);
  }

  envConfig = await configFactory({ region });
};

export const getEnvConfig = (): EnvRemoteConfig => {
  if (!envConfig) {
    throw new Error('Env config is not loaded yet, please use "loadEnvConfig"');
  }

  return envConfig;
};
